var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('DefaultTemplate',[_c('template',{slot:"header"},[_c('LogoOnlyHeader')],1),_vm._v(" "),_c('nuxt')],2):_c('MobileLayout',[_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }